import React from "react";
import "./LoadingCircleFacilitator.css";

const LoadingCircleFacilitator = () => {
  return (
    <div className="loading-container-facilitator">
      <div className="loading-spinner-facilitator"></div>
    </div>
  );
};

export default LoadingCircleFacilitator;
